import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import logo from "../../../logo.svg";
import styles from "./NavBar.module.scss";
import InformationButton from "../InformationButton/InformationButton";
import { AppBar, Button, Typography } from "@mui/material";
import ExportDropDown from "../SelectList(s)/ExportDropDown";
import InstructionsButton from "../Instructions/InstructionsButton";
import TopicEditorSelect from "../SelectList(s)/TopicEditorSelect";
import { Link } from "react-router";
import { useAuth0 } from "@auth0/auth0-react";

export default function NavBar(props: {
  csvData: any;
  data: any;
  pickedStates: any;
}): JSX.Element {
  const { csvData, data, pickedStates } = props;
  const { user } = useAuth0();

  return (
    <div>
      <AppBar className={styles.Header} elevation={2}>
        <Toolbar className={styles.HeaderDiv}>
          <Button className={styles.Button} component={Link} to="/app">
            <img className={styles.EggIcon} src={logo} alt="OPUS logo" />
            <Typography className={styles.TitleText}>OPUS</Typography>
          </Button>
          {user["https://www.magmutual.com/Auth0_Role"].includes(
            "Opus-admin",
          ) ? (
            <TopicEditorSelect />
          ) : null}

          {/* Only Renders Export Buttons on the main page */}
          {window.location.pathname === "/app" && (
            <ExportDropDown
              csvData={csvData}
              data={data}
              pickedStates={pickedStates}
            />
          )}
          {/* Div separates the navigation buttons; forces Instructions and Information to the right side */}
          <div className={styles.grow} />
          <InstructionsButton />
          <InformationButton />
        </Toolbar>
      </AppBar>
    </div>
  );
}
